import validate from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "express-checkout": () => import("D:/TeamCity/buildAgent2/work/d45ddfb12d6c0fc6/src/Presentation/ClientApp/middleware/expressCheckout.ts")
}